import React from "react";
import { Modal, Spin, Empty, Button } from "antd";
import {
  FileTextOutlined,
  CheckCircleFilled,
  CheckOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { BrandThemeProvider } from "../../../../ui";
import styles from "./QuizSelectModal.module.scss";

/**
 * QuizSelectModal — eleccion de test para una escena (Itinerarios, F4).
 * Tarjetas seleccionables (no radios planos): tile + nombre + descripcion +
 * chip con numero de preguntas. La activa lleva borde/glow verde de marca.
 */
export function QuizSelectModal({
  open,
  loading,
  quizzes = [],
  selectedQuizId,
  onSelect,
  onSkip,
  onConfirm,
}) {
  const { t } = useTranslation("evaluations");

  return (
    <BrandThemeProvider>
      <Modal
        open={open}
        onCancel={onSkip}
        centered
        width={560}
        title={
          <div className={styles.header}>
            <span className={styles.headerIcon}>
              <FileTextOutlined />
            </span>
            <div className={styles.headerText}>
              <span className={styles.headerTitle}>
                {t("evaluationGrid.selectQuizTitle")}
              </span>
              <span className={styles.headerSub}>
                {t("evaluationGrid.selectQuizSubtitle")}
              </span>
            </div>
          </div>
        }
        styles={{ body: { paddingTop: 8 } }}
        footer={[
          <Button key="skip" onClick={onSkip}>
            {t("evaluationGrid.enterWithoutTest")}
          </Button>,
          <Button
            key="confirm"
            type="primary"
            icon={<CheckOutlined />}
            disabled={!selectedQuizId}
            onClick={onConfirm}
          >
            {t("evaluationGrid.assignAndEnter")}
          </Button>,
        ]}
      >
        {loading ? (
          <div className={styles.center}>
            <Spin />
          </div>
        ) : quizzes.length === 0 ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={t("quiz.noQuizzes")}
          />
        ) : (
          <div className={styles.list} role="radiogroup">
            {quizzes.map((q) => {
              const active = selectedQuizId === q._id;
              const count = Array.isArray(q.questions) ? q.questions.length : 0;
              return (
                <button
                  type="button"
                  key={q._id}
                  role="radio"
                  aria-checked={active}
                  className={`${styles.item} ${active ? styles.active : ""}`}
                  onClick={() => onSelect?.(q._id)}
                >
                  <span className={styles.tile}>
                    <FileTextOutlined />
                  </span>
                  <span className={styles.info}>
                    <span className={styles.name}>{q.name}</span>
                    <span className={styles.desc}>
                      {q.description || t("evaluationGrid.noDescription")}
                    </span>
                    <span className={styles.meta}>
                      {t("evaluationGrid.questionsCount", { count })}
                    </span>
                  </span>
                  <span className={styles.check}>
                    {active ? (
                      <CheckCircleFilled className={styles.checkOn} />
                    ) : (
                      <span className={styles.checkOff} />
                    )}
                  </span>
                </button>
              );
            })}
          </div>
        )}
      </Modal>
    </BrandThemeProvider>
  );
}

export default QuizSelectModal;
